module.exports = __webpack_public_path__ + "img/13.9ef3dbad.webp";